const message = encodeURIComponent("Hellow JT Group");
const CTASection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "Ready to start your journey?",
      desc: "Let’s have a conversation about your future. Our advisors are here to listen, guide, and walk alongside you.",
      btn: "Request a Private Consultation",
    },

    zh: {
      title: "准备开始您的旅程了吗？",
      desc: "让我们一起讨论您的未来，我们的顾问将为您提供专业指导与支持。",
      btn: "预约私人咨询",
    },
  };

  return (
    <section
      className="relative bg-cover bg-top bg-center bg-no-repeat py-24"
      style={{
        backgroundImage:
          "url('/assets/images/businessman-woman-successful-with-work.jpg')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/25"></div>

      {/* Content */}
      <div className="relative max-w-[1200px] mx-auto px-4 text-center text-white">

        <h2 className="text-3xl md:text-4xl font-medium mb-4">
          {text[lang].title}
        </h2>

        <p className="max-w-2xl mx-auto text-sm md:text-base text-gray-200 mb-8">
          {text[lang].desc}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">

        <button
  onClick={() => {
    window.open(
      `https://wa.me/6596861698?text=${message}`,
      "_blank"
    );
  }}
  className="bg-[#1f4b5e] hover:bg-[#163946] transition-all duration-300 px-8 py-3 font-medium block mx-auto sm:mx-0"
>
  {text[lang].btn}
</button>

        </div>

      </div>
    </section>
  );
};

export default CTASection;